export enum CyclotronProductModelState {
	ACTIVE = 'ACTIVE',
	COMPLETELY_APPLIED = 'COMPLETELY_APPLIED',
	IN_WASTE_MANAGEMENT = 'IN_WASTE_MANAGED'
}